import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'
import axios from 'axios'

Vue.config.productionTip = false

Vue.prototype.$http = axios
Vue.prototype.$http.api = {
  baseUrl: "https://api.nipchallenge.com",
  user: {},
  jwt: "",
  checkLogin: (path, params) => {
    if (!Vue.prototype.$http.api.isLoggedIn()) {
      const redirect = {
        name: path ? path : 'home',
        params: params ? params : {}
      }

      router.push({name: 'login', params: redirect});

      return false;
    }

    return true;
  },
  delete: (url, config) => {
    return axios.delete(Vue.prototype.$http.api.getUrl(url), Vue.prototype.$http.api.getAuthorizationHeader(config));
  },
  get: (url, config) => {
    return axios.get(Vue.prototype.$http.api.getUrl(url), Vue.prototype.$http.api.getAuthorizationHeader(config));
  },
  getAuthorizationHeader: (config) => {
    if (!config) {
      config = {
        headers: {}
      }
    }
    else if (!config.headers) {
      config.headers = {};
    }
  
    config.headers.Authorization = `Bearer ${Vue.prototype.$http.api.jwt}`;
  
    return config;
  },
  getError: (e, noRedirect) => {
    let error = {
      error: "Bad Request",
      message: "",
      status: 400,
      toString: ""
    };

    if (error.response) {
      error.error = e.response.data ? e.response.data.error : e.response.statusText;
      error.message = e.response.data ? e.response.data.message : e.response.message;
      error.status = e.response.status;
      error.toString = `${error.error}: ${error.message}`;
    }
    else {
      error.toString = `${error.error}: ${e.message}`;
    }
    
    if (error.status == 401 && !noRedirect) {
      router.push({name:"login"});
    }

    return error;
  },
  getUrl: (url) => {
    return Vue.prototype.$http.api.baseUrl + url;
  },
  isLoggedIn: () => {
    return Vue.prototype.$http.api.jwt != "";
  },
  post: (url, data, config) => {
    data = data ? data : {};

    return axios.post(Vue.prototype.$http.api.getUrl(url), data, Vue.prototype.$http.api.getAuthorizationHeader(config));
  },
  put: (url, data, config) => {
    data = data ? data : {};

    return axios.put(Vue.prototype.$http.api.getUrl(url), data, Vue.prototype.$http.api.getAuthorizationHeader(config));
  }
}

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
